import React, {useMemo} from 'react'
import { useTranslation } from 'react-i18next'
import {Timeline} from 'antd'
import moment from 'moment-timezone'
import {getAmountWithCurrency} from '@/utils'
import {DATE_TIME_FORMAT} from '@/constants'
import {DEFAULT_CURRENCY} from '@/constants/currencies'
import {getOnlinePaymentStatusName} from '@/pages/OnlinePayments/services'
import {ChildTransactionsPropsType} from '@/pages/OnlinePayments/components/ChildTransactionsDetails/props'
import {TimelineRow} from '@/pages/OnlinePayments/components/TimelineRow'
import styles from './styles.scss'

export const ChildTransactionsDetails = ({details}: ChildTransactionsPropsType) => {
    const { t } = useTranslation()
    const formattedDetails = useMemo(
        () =>
            details.map(tx => ({
                ...tx,
                formattedDate: moment(tx.createdDate).format(DATE_TIME_FORMAT)
            })),
        [details]
    )

    return (
        <Timeline mode={'left'} className={styles.timeline}>
            {
                formattedDetails.map((transaction) => (
                    <Timeline.Item
                        key={transaction.id}
                        label={moment(transaction.createdDate).format(DATE_TIME_FORMAT)}
                        className={styles.timelineItem}
                    >
                        <TimelineRow label={t('OnlinePayments.id')}>{transaction.id}</TimelineRow>
                        <TimelineRow label={t('OnlinePayments.amount')}>
                            {getAmountWithCurrency(transaction.amount, transaction.currency || DEFAULT_CURRENCY)}
                        </TimelineRow>
                        <TimelineRow label={t('OnlinePayments.transactionDate')}>
                            {moment(transaction.createdDate).format(DATE_TIME_FORMAT)}
                        </TimelineRow>
                        <TimelineRow label={t('OnlinePayments.status')}>
                            {getOnlinePaymentStatusName(transaction.status)}
                        </TimelineRow>
                        <TimelineRow label={t('OnlinePayments.orderNumber')}>{transaction.invoiceId}</TimelineRow>
                        <TimelineRow label={t('OnlinePayments.transactionType')}>
                            {transaction?.transactionType ? t(`enums:transactionTypes.${transaction.transactionType.toUpperCase()}`, { defaultValue: transaction.transactionType.toUpperCase() }) : ''}
                        </TimelineRow>
                    </Timeline.Item>
                ))
            }
        </Timeline>
    )
}
